/**
 * maintain this enum for image zoom feature for specific tab
 */
export enum ImageZoomRoutingPaths {
  AssetInfo = 'asset-info',
  AssetData = 'asset-data',
  AssetUsageRights = 'asset-usage-rights',
  AssetTagging = 'asset-tagging-n-taxonomy',
  AssetVersions = 'asset-versions',
}
